/* =====================================================
   ipGeolocation component
   Displays flag + region + IP in a single line.
   Auth token is injected automatically by the $http interceptor.

   Usage:
     <ip-geolocation></ip-geolocation>               ← auto-detect caller IP
     <ip-geolocation ip="'76.50.194.196'"></ip-geolocation>  ← explicit IP
   ===================================================== */
angular.module('bizmetryApp').component('ipGeolocation', {

  bindings: {
    ip: '<'   // optional — if omitted, backend auto-detects caller IP
  },

  template: `
    <style>
      .ip-geo-container {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 0.85em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .ip-geo-flag      { font-size: 1.3em; line-height: 1; flex-shrink: 0; }
      .ip-geo-region    { font-weight: 500; overflow: hidden; text-overflow: ellipsis; }
      .ip-geo-separator { opacity: 0.4; flex-shrink: 0; }
      .ip-geo-ip        { font-family: monospace; opacity: 0.75; font-size: 0.95em; flex-shrink: 0; }
      .ip-geo-loading   { opacity: 0.45; font-style: italic; font-size: 0.85em; }
      .ip-geo-fallback  { font-family: monospace; opacity: 0.65; font-size: 0.85em; }
    </style>

    <!-- Loading -->
    <span ng-if="$ctrl.loading" class="ip-geo-loading">···</span>

    <!-- Resolved -->
    <span ng-if="!$ctrl.loading && $ctrl.geo" class="ip-geo-container">
      <span class="ip-geo-flag">{{$ctrl.flag}}</span>
      <span class="ip-geo-region">{{$ctrl.geo.city}}<span ng-if="$ctrl.geo.city && $ctrl.geo.region">, </span>{{$ctrl.geo.region}}</span>
      <span class="ip-geo-separator">·</span>
      <span class="ip-geo-ip">{{$ctrl.geo.ip}}</span>
    </span>

    <!-- Fallback — geo failed -->
    <span ng-if="!$ctrl.loading && !$ctrl.geo" class="ip-geo-fallback">
      {{$ctrl.ip || '—'}}
    </span>
  `,

  controller: ['geoLocationService', 'bizFlagUtils',
    function (geoLocationService, bizFlagUtils) {

    const $ctrl = this;

    $ctrl.loading = false;
    $ctrl.geo     = null;
    $ctrl.flag    = '';

    $ctrl.$onInit = function () {
      load();
    };

    $ctrl.$onChanges = function (changes) {
      if (changes.ip && !changes.ip.isFirstChange()) {
        load();
      }
    };

    function load() {
      $ctrl.loading = true;
      $ctrl.geo     = null;
      $ctrl.flag    = '';

      var ipToResolve = ($ctrl.ip && $ctrl.ip.trim()) ? $ctrl.ip.trim() : null;

      geoLocationService.geolocate(ipToResolve)
        .then(function (geo) {
          $ctrl.geo  = geo;
          $ctrl.flag = geo ? bizFlagUtils.toFlag(geo.country_code) : '';
        })
        .catch(function (err) {
          console.warn('📍 [ipGeolocation] error:', err);
        })
        .finally(function () {
          $ctrl.loading = false;
        });
    }

  }]
});